
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import styled from "styled-components"
import { showModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import oo from "../../../images/img/oo.png"
import Button from "../../shared/button/Button"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 800px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 30px 20px 30px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .img-kamyonoo{
            width: 80px;
            height: 40px;
            margin-bottom: 20px;
        }

        h2{
            font-weight: var(--font-weight-lg);
            font-size: var(--font-size-lg);
            margin-bottom: 30px;
        }

        p{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            margin-bottom: 30px;

        }

        .btn-grp{
            margin-top: 30px;
            width: 80%;
            display: flex;
            justify-content: center;
        }           
    }
`

const AddLoadSuccessModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

 
  return (
    <Container onClick={()=> dispatch(showModal(null))}>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <img src={oo} alt="kamyoon" className="img-kamyonoo" />
            <h2>Tebrikler... Yük Kaydınız Başarıyla Tamamlanmıştır</h2>
            <div className="btn-grp">
                <Button handleClick={() => { dispatch(showModal(null)); navigate("/yukler-listesi")}} text={"Harika"} width="45%" background={"#E85446"} />
            </div>
        </div>
    </Container>
  )
}

export default AddLoadSuccessModal